export const Lab = (destinationLang) => {
  return [
    {
      FormKey: 'lab-patient-type-lab',
      Key: 'آزمایشگاه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-type-confirmation',
      Key: 'وضعیت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-type-confirm-not-confirmed',
      Key: 'تایید نشده',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-type-confirm-confirmed',
      Key: 'تایید شده',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-type-confirm-canceled',
      Key: 'رد شده',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-type-confirm-all',
      Key: 'همه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-date-insert',
      Key: 'تاریخ درخواست',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-file-number',
      Key: 'شماره پرونده',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-number-request',
      Key: 'شماره درخواست',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-name-patient',
      Key: 'نام بیمار',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-family-patient',
      Key: 'نام خانوادگی بیمار',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-tarikh-type-paziresh',
      Key: 'پذیریش',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-tarikh-type-javab-dehi',
      Key: 'جواب دهی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-tarikh-type-label',
      Key: 'بر اساس',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-accept-answer',
      Key: 'آزمایشگاه تشخیصی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-cancel-answer',
      Key: 'ابطال جواب',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-reject-answer',
      Key: 'رد درخواست',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-confirm-see-answer',
      Key: 'آیا از مشاهده جواب اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-confirm-accept-answer',
      Key: 'آیا از تایید جواب اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-confirm-cancel-answer',
      Key: 'آیا از ابطال جواب اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-confirm-reject-answer',
      Key: 'آیا از رد درخواست اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-record-count',
      Key: 'تعداد رکورد',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-reject-reason',
      Key: 'دلیل رد درخواست خود را وارد کنید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-patient-id-textbox',
      Key: 'شماره شناسه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'lab-patient-see-asnwers-lab',
      Key: 'مشاهده جواب',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'lab-patient-operation-accept-answer-operation',
      Key: 'تایید جواب',
      DistinitationLanguage: destinationLang,
    },
  ];
};
